import { useEffect } from "react";
import { useLocation } from "wouter";

export default function RegisterManagerRedirect() {
  const [, navigate] = useLocation();
  useEffect(() => {
    navigate("/auth?tab=register&role=manager", { replace: true });
  }, [navigate]);
  return null;
} 